import angular from 'angular';

import template from './template.html';

function SchedulePickerDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: 'ngModel',
    scope: {
      ngModel: '='
    },
    template,
    link: function ($scope, $element, $attrs, ctrl) {
      $scope.periods = [{
        name: 'AM'
      }, {
        name: 'PM'
      }];

      const dateFormatRegex = new RegExp(/^\d{1,2}:\d{2}\s{1}.[amAMpmPM]$/);

      $scope.times = [
        '12:00', '12:30', '1:00', '1:30', '2:00', '2:30', '3:00', '3:30',
        '4:00', '4:30', '5:00', '5:30', '6:00', '6:30', '7:00', '7:30',
        '8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30'
      ];

      function ScheduleDay(day) {
        this.day = day;
        this.closed = true;
        this.hours = [{
          startTime: null,
          startMeridian: $scope.periods[1],
          endTime: null,
          endMeridian: $scope.periods[1]
        }];
      }
      ScheduleDay.prototype.addHours = function ($event) {
        const _this = this;

        if ($event) $event.preventDefault();

        _this.hours.push({
          startTime: null,
          startMeridian: $scope.periods[1],
          endTime: null,
          endMeridian: $scope.periods[1]
        });

        ctrl.$dirty = true;
      };
      ScheduleDay.prototype.select = function () {
        const _this = this;

        if (_this.closed) {
          _this.closed = false;
        } else {
          _this.closed = true;
        }

        _this.reset();

        ctrl.$dirty = true;
      };
      ScheduleDay.prototype.removeHours = function (index, $event) {
        const _this = this;

        if ($event) $event.preventDefault();

        if (_this.hours.length === 1) {
          _this.closed = true;
        } else {
          _this.hours.splice(index, 1);
        }
        _this.validate();

        ctrl.$dirty = true;
      };
      ScheduleDay.prototype.reset = function () {
        const _this = this;

        _this.hours = [];
        _this.addHours();

        ctrl.$dirty = true;
      };
      ScheduleDay.prototype.validate = function () {
        const _this = this;

        if (_this.hours && _this.hours.length) {
          for (let i = 0; i < _this.hours.length; i++) { //eslint-disable-line
            const hourGroup = _this.hours[i];

            if (_this.closed) {
              hourGroup.invalidStartTime = false;
              hourGroup.invalidEndTime = false;
              hourGroup.invalidRange = false;

              if (hourGroup.startTime) hourGroup.startTime = null;
              if (hourGroup.endTime) hourGroup.endTime = null;
            } else {
              if (!hourGroup.startTime) hourGroup.invalidStartTime = true;
              else hourGroup.invalidStartTime = false;
              if (!hourGroup.endTime) hourGroup.invalidEndTime = true;
              else hourGroup.invalidEndTime = false;

              if (hourGroup.invalidStartTime && hourGroup.invalidEndTime) {
                hourGroup.invalidRange = true;
              } else {
                hourGroup.invalidRange = false;
              }
            }
          }
        }
      };

      $scope.scheduleDays = [
        new ScheduleDay(1),
        new ScheduleDay(2),
        new ScheduleDay(3),
        new ScheduleDay(4),
        new ScheduleDay(5),
        new ScheduleDay(6),
        new ScheduleDay(0)
      ];

      $scope.getDayFromNumber = function (dayNumber) {
        switch (dayNumber) {
        case 0:
          return 'Sun';
        case 1:
          return 'Mon';
        case 2:
          return 'Tue';
        case 3:
          return 'Wed';
        case 4:
          return 'Thur';
        case 5:
          return 'Fri';
        case 6:
          return 'Sat';
        default:
          throw new Error('invalid day :' + dayNumber); //eslint-disable-line
        }
      };

      // ----------------------------------------------------------------- //
      // NgModelCtrl
      // ----------------------------------------------------------------- //

      //deep watch the collection of schedule days to update the model - this will trigger the validate function to run
      $scope.$watch('scheduleDays', function (val) {
        ctrl.$setViewValue(angular.copy(val)); //hackyness - copy value otherwise $parsers don't run

        ctrl.$dirty = true;
      }, true);

      //parser takes the directive value and sets the model value
      ctrl.$parsers.unshift(function (viewValue) {
        validate(viewValue);

        return viewValue;
      });

      //formatter takes the model value and intializes the directive
      //directive expects schedule hours to be unix timestamps
      //TODO: provide way to parse other formats for input
      ctrl.$formatters.push(function (modelValue) {
        let i;
        let j;

        if (modelValue && modelValue.length) {
          for (i = 0; i < modelValue.length; i++) { //eslint-disable-line
            const modelDay = modelValue[i];

            const day = modelDay.day === 0 ? 6 : modelDay.day - 1;
            const scheduleDay = $scope.scheduleDays[day];

            if (scheduleDay) {
              scheduleDay.closed = modelDay.closed;

              if (!scheduleDay.closed && modelDay.hours && modelDay.hours.length) {
                scheduleDay.hours = [];

                for (j = 0; j < modelDay.hours.length; j++) { //eslint-disable-line
                  const modelHour = modelDay.hours[j];
                  //const scheduleDayHours = scheduleDay.hours[j];
                  const scheduleDayHours = {};

                  if (!dateFormatRegex.test(modelHour.start)) throw new Error(modelHour.start + ' is not in the format 09:00 AM'); //eslint-disable-line
                  if (!dateFormatRegex.test(modelHour.end)) throw new Error(modelHour.end + ' is not in the format 09:00 AM'); //eslint-disable-line

                  const startPieces = modelHour.start.split(' ');
                  scheduleDayHours.startTime = findTime($scope.times, startPieces[0]);
                  scheduleDayHours.startMeridian = startPieces[1] === 'AM' ? $scope.periods[0] : $scope.periods[1];

                  const endPieces = modelHour.end.split(' ');
                  scheduleDayHours.endTime = findTime($scope.times, endPieces[0]);
                  scheduleDayHours.endMeridian = endPieces[1] === 'AM' ? $scope.periods[0] : $scope.periods[1];

                  scheduleDay.hours[j] = scheduleDayHours;
                }
              }
            }
          }
        }

        return modelValue;
      });

      // ctrl.$render = function() {
      //   console.log('render');
      //   console.log(ctrl.$modelValue);

      //   //$scope.scheduleDays = ctrl.$modelValue;
      // };

      // ----------------------------------------------------------------- //
      // Private Helpers
      // ----------------------------------------------------------------- //
      function validate(viewValue) {
        const requiredAttr = $attrs.required;

        if (requiredAttr && !viewValue) {
          ctrl.$setValidity('required', false);
        } else {
          ctrl.$setValidity('required', true);
        }

        validateAndScrubScheduleValues();

        return viewValue;
      }

      function validateAndScrubScheduleValues() {
        //validate the schedule values and pull out any values that should be set on the model
        let j;
        let invalidRange;
        let invalidStartTime;
        let invalidEndTime;

        /* eslint-disable */

        for (let i = 0; i < $scope.scheduleDays.length; i++) {
          const schedule = $scope.scheduleDays[i];

          schedule.validate();

          if (schedule.closed) {
            continue;
          }

          if (!schedule.closed && (!schedule.hours || !schedule.hours.length)) {
            invalidRange = true;
            break;
          }

          if (schedule.hours && schedule.hours.length) {
            for (j = 0; j < schedule.hours.length; j++) {
              var hours = schedule.hours[j];

              if (!schedule.closed && (!hours.startTime || !hours.endTime)) {
                invalidRange = true;
                invalidStartTime = true;
                invalidEndTime = true;
                break;
              }

              hours.start = hours.startTime + ' ' + hours.startMeridian.name;
              hours.end = hours.endTime + ' ' + hours.endMeridian.name;
            }
          }
        }

        /* eslint-enable */

        if (invalidRange) {
          ctrl.$setValidity('invalidRange', false);
        } else {
          ctrl.$setValidity('invalidRange', true);
        }

        if (invalidStartTime) {
          ctrl.$setValidity('invalidStartTime', false);
        } else {
          ctrl.$setValidity('invalidStartTime', true);
        }

        if (invalidEndTime) {
          ctrl.$setValidity('invalidEndTime', false);
        } else {
          ctrl.$setValidity('invalidEndTime', true);
        }
      }

      function findTime(times, time) {
        let foundTime;

        //remove leading 0
        if (time.length === 5 && (time.substring(0, 1) === 0 || time.substring(0, 1) === '0')) {
          time = time.substring(1, time.length);
        }

        for (let i = 0; i < times.length; i++) { //eslint-disable-line
          const currentTime = times[i];

          if (currentTime === time) {
            foundTime = time;
            break;
          }
        }

        return foundTime;
      }
    }
  };
}

SchedulePickerDirective.$inject = [];

export default SchedulePickerDirective;



// WEBPACK FOOTER //
// ./src/directives/schedulePicker/index.js